import { AwsOidcAccesses } from "@p0security/integrations-aws-oidc-shared/accesses";
import { Access, Delegate } from "@p0security/shared/types/access/index";

import { DynamoDbAiLevels } from "./levels.ts";

/**
 * The one access. It grants an agent's session read or write on one table and
 * its indexes, through a statement in a role of the account's aws-oidc pool.
 */
export const DynamoDbAiAccesses = {
  table: Access({
    delegation: {
      "aws-oidc": Delegate({
        resource: "aws-oidc",
        accesses: AwsOidcAccesses,
        key: "identity",
      }),
    },
    description:
      "Read or write access to one DynamoDB table and its indexes, granted to an agent's session through a role in the account's AWS OIDC role pool",
    generated: {
      arn: { label: "Table ARN", type: "string" },
      partition: { label: "AWS partition", type: "string" },
    },
    label: "Table",
    maturity: "beta",
    // Required parameters are CLI positionals, in this order.
    parameters: {
      account: {
        description: "An installed AWS account, by ID",
        label: "Account",
        type: "dynamic",
      },
      region: {
        description: "The AWS Region the table is in",
        label: "Region",
        type: "dynamic",
      },
      table: {
        description: "The table name",
        label: "Table",
        type: "dynamic",
      },
      level: {
        choices: DynamoDbAiLevels,
        description:
          "read, or write, which also lets the agent put, update and delete items",
        label: "Level",
        type: "static",
      },
    },
    render: {
      locator: "account",
      policy: "level",
      resource: "table",
    } as const,
  }),
};

export type DynamoDbAiAccesses = typeof DynamoDbAiAccesses;
